import type { StateCreator } from 'zustand';

/**
 * Layout assistant model + temperature picker state.
 *
 * Lives in the global store (and is included in the persisted partialize
 * config in `store/index.ts`) so that two callers stay in sync without a
 * localStorage side-channel:
 *
 * - `TemplateVibecoder.tsx` — interactive picker / popover.
 * - `formSchemaLayoutGenerationSlice.ts` — the "generate full layout"
 *   automation triggered from the Form Tree.
 *
 * `null` for either field means "use whatever the backend default is" — both
 * are forwarded only when set, so the backend registry's default applies.
 */
export interface VibecoderSettingsSlice {
  vibecoderModelId: string | null;
  vibecoderTemperature: number | null;
  setVibecoderModelId: (modelId: string | null) => void;
  setVibecoderTemperature: (temperature: number | null) => void;
}

export const vibecoderSettingsSlice: StateCreator<
  VibecoderSettingsSlice
> = set => ({
  vibecoderModelId: null,
  vibecoderTemperature: null,
  setVibecoderModelId: modelId => set({ vibecoderModelId: modelId }),
  setVibecoderTemperature: temperature =>
    set({ vibecoderTemperature: temperature }),
});
